import { Routes, Route } from "react-router-dom";
import StoreLayout from "../layout/StoreLayout";
import StoreHome from "../pages/store/StoreHome";
import ProductDetail from "../pages/store/ProductDetail";
import LoginPage from "../pages/store/LoginPage";
import AccountPage from "../pages/cliente/AccountPage";
import Cart from "../pages/store/page/Cart";
import Checkout from "../pages/store/page/Checkout";
import CheckoutSuccess from "../pages/store/page/CheckoutSuccess";
import CheckoutPayment from "../pages/store/page/CheckoutPayment";
import CheckoutPending from "../pages/store/page/CheckoutPending";

function StoreRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/account" element={<AccountPage />} />

      <Route element={<StoreLayout />}>
        <Route index element={<StoreHome />} />
        <Route path="product/:id" element={<ProductDetail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="checkout/payment" element={<CheckoutPayment />} />
        <Route path="checkout/success" element={<CheckoutSuccess />} />
        <Route path="checkout/pending" element={<CheckoutPending />} />
      </Route>
    </Routes>
  );
}

export default StoreRoutes;
